import script from "./risklist.vue?vue&type=script&setup=true&lang=js"
export * from "./risklist.vue?vue&type=script&setup=true&lang=js"

import "./risklist.vue?vue&type=style&index=0&id=4da2b0ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4da2b0ee"]])

export default __exports__